import { apiClient, getErrorMessage } from './client'

export { getErrorMessage }

export interface ApiKey {
  _id: string
  name: string
  isActive: boolean
  createdAt: string
  lastUsedAt?: string
}

export interface NewApiKey extends ApiKey {
  key: string // raw key — returned only on creation
}

export async function listApiKeys(appId: string): Promise<ApiKey[]> {
  const response = await apiClient.get<{ apiKeys: ApiKey[] }>(
    `/admin/applications/${appId}/api-keys`
  )
  return response.data.apiKeys
}

export async function createApiKey(appId: string, name: string): Promise<NewApiKey> {
  const response = await apiClient.post<{ apiKey: NewApiKey }>(
    `/admin/applications/${appId}/api-keys`,
    { name }
  )
  return response.data.apiKey
}

export async function revokeApiKey(appId: string, keyId: string): Promise<void> {
  await apiClient.delete(`/admin/applications/${appId}/api-keys/${keyId}`)
}
